import { Modal, Button, Text, Icon } from '@/components'
import { useState } from 'react'

export default function CostCategoryAnnualSavingsModal() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Modal
      title="How are savings calculated?"
      id="cost-category-annual-savings-modal"
      open={isModalOpen}
      onOpen={() => setIsModalOpen(true)}
      onClose={() => setIsModalOpen(false)}
    >
      <Modal.Activator>
        <Icon
          name="Info"
          size={16}
          className="text-themed-grey-400 cursor-pointer"
          aria-label="How are savings calculated?"
        />
      </Modal.Activator>
      <Text variant="body2" className="mb-4">
        This estimate is based on thermostats that used the Save Money feature
        during summer 2025. We calculated the average AC savings per thermostat
        from May to October based on their hourly energy rates.
      </Text>
      <Modal.Actions>
        <Button
          id="annual-savings-modal-close-button"
          onClick={() => setIsModalOpen(false)}
          variant="primary"
        >
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
